import { Component, EventEmitter, Input, Output } from '@angular/core';

import { TranslationService } from '@mirage-projects/cw-commons';
import { NumberHelperService } from '@mirage-projects/cw-utils';

export const defaultSphereSizes = ['30', '69.5', '100'] as const;

/**
 * This component is used to add and show a list of spheres radius (max 3 values)
 */
@Component({
    selector: 'cw-sphere-radius-chips',
    templateUrl: 'sphere-radius-chips.component.html',
    styleUrls: ['./sphere-radius-chips.component.scss'],
    standalone: false,
})
export class SphereRadiusChipsComponent {
    constructor(
        private translationService: TranslationService,
        private numberHelperService: NumberHelperService
    ) {}
    /** Chips list changes event */
    @Output() chipsChange = new EventEmitter<string[]>();

    /** List of chips */
    @Input() chips: string[] = [];

    minSphereRadius = 10;
    maxSphereRadius = 200;

    valueValidationRadius = (value: string | undefined): string | null => {
        if (!value) {
            return this.translationService.translate('GENERAL.INVALID_VALUE');
        }

        const num = Number(value);
        if (!this.numberHelperService.isValidNumber(num)) {
            return this.translationService.translate('GENERAL.INVALID_VALUE');
        }

        if (num < this.minSphereRadius) {
            return `${this.translationService.translate('SCANPROC.SCAN_PROCESSING_WARN_MIN_SPHERE', {
                value: this.minSphereRadius,
            })}`;
        }

        if (num > this.maxSphereRadius) {
            return `${this.translationService.translate('SCANPROC.SCAN_PROCESSING_WARN_MAX_SPHERE', { value: this.maxSphereRadius })}`;
        }

        const decimalPart = num.toString().split('.')[1];
        const hasTooManyDecimals = decimalPart?.length > 4;
        if (hasTooManyDecimals) {
            return `${this.translationService.translate('SCANPROC.SCAN_PROCESSING_WARN_DECIMALS_SPHERE', { value: 4 })}`;
        }
        return null;
    };

    emitChips(chips: string[]): void {
        this.chipsChange.emit(chips);
    }
}
